import { useEffect } from 'react';

import useBranchId from '@maya/hooks/useBranchId';
import useTranslate from '@maya/hooks/useTranslate';
import { useAppDispatch, useAppSelector } from '@maya/store/hooks';
import { loadEmployee, selectEmployee } from '@maya/store/slices/employee';

export default function useEmployee(employeeId?: string) {
  const branchId = useBranchId();
  const t = useTranslate();

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!employeeId || !branchId) {
      return;
    }

    dispatch(loadEmployee(branchId, employeeId, t));
  }, [branchId, dispatch, employeeId, t]);

  return useAppSelector(selectEmployee);
}
